'use client';

import { useContext } from 'react';
import { ProductContext } from './contexts';

/**
 * The static part of the product data. Safe to read anywhere, never suspends.
 */
export function useProduct() {
  const productCtx = useContext(ProductContext);

  if (productCtx === undefined) {
    throw new Error('useProduct must be used within a ProductProvider');
  }

  return productCtx;
}
